import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import axios from 'axios'
class EventAdd extends React.Component {
  state = {
    is_active: 'true',
    event_image: '',
    isSaving: false,
    event_desc_ar: '',
    event_desc_en: '',
    amount: '',
    event_name_ar: '',
    pickup_id: '',
    event_name_en: '',
    restaurant_board_list: '',
    isData: false,
    Edit: false,
    price_before_markup: '',
  }

  componentDidMount() {
    this.PickupList()

    if (this.props.event_id) {
      this.EventLists()
    }
  }

  PickupList = async () => {
    var that = this
    await axios
      .get(Constant.getAPI() + `/admin/pick-up-listing`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            Products_data: res?.data?.data,
          })
        }
      })
      .catch((err) => {
        that.setState({ isData: false })

        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  EventLists = async () => {
    await axios
      .get(Constant.getAPI() + `/event/list-events`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data?.success) {
          const matchItem = res.data?.data?.filter((itm) => itm.id === this.props.event_id)
          if (matchItem?.length) {
            const itm = matchItem[0]

            this.setState({
              ...itm,
              Edit: true,
            })
          }
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChangeRestaurant = (event) => {
    this.setState({ restaurant_board_list: event })
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  handleChangeImage = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] })
    this.setState({ Edit: false })
    this.setState({ img: URL.createObjectURL(e.target.files[0]) })
  }

  dashbord = async () => {
    var that = this
    const formData = new FormData()
    formData.append('is_active', that.state.is_active)
    formData.append('event_desc_ar', that.state.event_desc_ar)
    formData.append('event_desc_en', that.state.event_desc_en)
    formData.append('amount', that.state.amount)
    formData.append('price_before_markup', that.state.price_before_markup || '')
    formData.append('pickup_id', that.state.pickup_id)
    formData.append('event_name_ar', that.state.event_name_ar)
    formData.append('event_name_en', that.state.event_name_en)
    formData.append('restaurant_board_list', that.state.restaurant_board_list)

    if (that.props.event_id) {
      formData.append('id', that.props.event_id)
      if (that.state.event_image?.name) {
        formData.append('event_image', that.state.event_image)
      }
      that.setState({ isData: true })

      await axios
        .put(Constant.getAPI() + '/event/edit-new-event', formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then(() => {
          that.setState({ isData: false })
          Swal.fire({
            title: 'Event updated Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
          window.location.href = '#/events'
        })
        .catch((err) => {
          that.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      if (that.state.event_image?.name) {
        formData.append('event_image', that.state.event_image)
      }
      that.setState({ isData: true })

      await axios
        .post(Constant.getAPI() + '/event/add-new-event', formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then(() => {
          that.setState({ isData: false })
          Swal.fire({
            title: 'Event added Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
          window.location.href = '#/events'
        })
        .catch((err) => {
          that.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Event Name : English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="event_name_en"
                    id="event_name_en"
                    placeholder="Event Name: English"
                    onChange={this.handleChange}
                    value={this.state.event_name_en}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Event Name : Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="event_name_ar"
                    id="event_name_ar"
                    placeholder="Event Name: Arabic"
                    onChange={this.handleChange}
                    value={this.state.event_name_ar}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Event Description : English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="event_desc_en"
                    id="event_desc_en"
                    placeholder="Event Description: English"
                    onChange={this.handleChange}
                    value={this.state.event_desc_en}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Event Description : Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="event_desc_ar"
                    id="event_desc_ar"
                    placeholder="Event Description: Arabic"
                    onChange={this.handleChange}
                    value={this.state.event_desc_ar}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Pickup list</label>
                <div className="col-sm-9">
                  <select
                    name="pickup_id"
                    className="form-control"
                    onChange={this.handleChange}
                    value={this.state.pickup_id}
                  >
                    <option>Select pickup</option>
                    {this.state?.Products_data !== undefined &&
                    this.state?.Products_data !== null &&
                    this.state?.Products_data !== [] &&
                    this.state?.Products_data?.length > 0
                      ? this.state.Products_data?.map((itm) => (
                          <option
                            value={itm?.id}
                            key={itm?.id}
                          >
                            {itm?.pickup_address_en}
                            {'/ '}
                            {itm?.pickup_address_ar}
                          </option>
                        ))
                      : null}
                  </select>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Amount</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="amount"
                    id="amount"
                    placeholder="Amount"
                    onChange={this.handleChange}
                    value={this.state.amount}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Price Before Markup</label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    name="price_before_markup"
                    id="price_before_markup"
                    placeholder="Price Before Markup"
                    onChange={this.handleChange}
                    value={this.state.price_before_markup}
                    min={0}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Status</label>
                <div className="col-sm-9">
                  <select
                    name="status"
                    className="form-control"
                    value={this.state.status}
                    onChange={this.handleChange}
                  >
                    <option
                      value="true"
                      name="is_active"
                    >
                      Active
                    </option>
                    <option
                      value="flase"
                      name="is_active"
                    >
                      InActive
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3"> Image</div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <div>
                      <input
                        type="file"
                        id="img"
                        name="event_image"
                        accept="image/*"
                        className="w-100"
                        onChange={this.handleChangeImage}
                      />
                    </div>
                  </div>
                  {this.state.Edit ? (
                    <img
                      width="250px"
                      height="200px"
                      src={Constant.getImage() + this.state.event_image}
                      alt="img"
                    />
                  ) : (
                    <img
                      width="250px"
                      height="200px"
                      src={this.state.img}
                      alt="img"
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Details/تفاصيل</label>
                <div className="col-sm-12">
                  <ReactQuill
                    className="form-control"
                    name="restaurant_board_list"
                    id="restaurant_board_list"
                    value={this.state.restaurant_board_list}
                    onChange={this.handleChangeRestaurant}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row float-right p-3">
            <button
              onClick={this.dashbord}
              className="btn btn-grd-disabled mr-2"
            >
              <i className="icofont icofont-save"></i> Save
            </button>

            <Link
              to={'/events'}
              className="btn btn-outline-dark"
            >
              Cancel
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default EventAdd
